// @flow
import * as React from 'react';
import type { intlShape } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import Head from 'next/head';
import GlobalCss from '../../../common/GlobalCss';
import messages from '../../messages';
import serpMessages from '../../../Serp/messages';
import Footer from '../../../components/mobile/Footer';
import Suggestions from '../../../Suggestions/components/SuggestionsList/container';
import HeaderSerp from '../../../common/Header/HeaderSerp/container';
import styles from './styles';
import * as TrackEvents from '../../../tracking/events';
import setSearchFiltersVisibility from '../../../Serp/components/Filters/shared/utils/setSearchFiltersVisibility';
import GdprCookieBanner from '../../../Gdpr/components/mobile/GdprCookieBanner/container';

type Props = {
  what: ?string,
  intl: intlShape,
  filtersCount: number,
  trackEvent: Function,
  showSearchFilters: Function,
  hideSearchFilters: Function,
};

function Error204({
  what,
  intl,
  filtersCount,
  trackEvent,
  showSearchFilters,
  hideSearchFilters,
}: Props): React.Node {
  function showFilters() {
    setSearchFiltersVisibility({
      visibility: true,
      trackEvent,
      showSearchFilters,
      hideSearchFilters,
      TrackEvents,
    });
  }

  const filtersCountToDisplay = filtersCount > 0 ? `(${filtersCount})` : '';

  return (
    <div>
      <Head>
        <title>
          {intl.formatMessage(messages.noResults)}: {what}
        </title>
        <meta name="robots" content="noindex,nofollow,noarchive" />
        <meta name="googlebot" content="noindex,nofollow,noarchive" />
        <GlobalCss />
      </Head>
      <div className="main" data-test="noresults">
        <HeaderSerp currentSearch={what} />
        <GdprCookieBanner />

        <a className="filter" onClick={showFilters} data-test="open-filters">
          <FormattedMessage {...serpMessages.filtersTitle} /> {filtersCountToDisplay} &raquo;
        </a>
        <div className="notFoundMessage">
          <h1>
            <FormattedMessage {...messages.noResults} />: <span className="errorQuery">{what}</span>
          </h1>
        </div>
        <div className="recommendations">
          <h2>
            <FormattedMessage {...messages.weSuggest} />
          </h2>
          <ul>
            <li>
              <FormattedMessage {...messages.suggestion1} />
            </li>
            <li>
              <FormattedMessage {...messages.suggestion2} />
            </li>
          </ul>
        </div>
        <Suggestions />
      </div>
      <Footer />
      <style jsx>{styles}</style>
    </div>
  );
}

export default Error204;



// WEBPACK FOOTER //
// ./app/Error/components/Error204/index.js